import React from "react";
import { twMerge } from "tailwind-merge";
import TextField from "@mui/material/TextField";
import { CMSData } from "@/cms/models";

interface TextInputProps {
  required: boolean;
  label: string;
  defaultValue: string;
  errors: string[] | undefined;
  name: string;
  className?: string;
  cmsData: CMSData;
}

const TextInput: React.FC<TextInputProps> = ({
  required,
  label,
  defaultValue,
  errors,
  name,
  className = "",
  cmsData,
}) => {
  const style = cmsData.forms.style;
  const renderTextField = (variant: any) => (
    <TextField
      required={required}
      error={!!errors}
      className={twMerge("flex col-span-3 flex-col ", className)}
      label={label}
      size={style?.size}
      variant={variant}
      defaultValue={defaultValue}
      name={name}
      helperText={errors ? errors[0] : undefined}
    />
  );

  switch (style?.type) {
    case "material-outlined":
      return renderTextField("outlined");
    case "material-standard":
      return renderTextField("standard");
    default:
      return renderTextField("filled");
  }
};

export default TextInput;
